import { PageFallback } from "@jana-technology/platform-ui";
import { useLocation, useNavigate } from "react-router-dom";
import { DEFAULT_ROUTE } from "constants/routing";

const PathParagraph = ({ children }: React.PropsWithChildren) => (
  <span>
    The path{" "}
    <code className="rounded bg-grey-100 px-2 text-grey-900">{children}</code>{" "}
    is invalid. Please try another.
  </span>
);

export const NotFound404 = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <PageFallback
      heading="Page not found"
      paragraph={<PathParagraph>{pathname}</PathParagraph>}
      onPrimaryClick={() => navigate(DEFAULT_ROUTE)}
      onSecondaryClick={() => navigate(-1)}
    />
  );
};

export default NotFound404;
